<template>
<div>
   <PageInfo v-if="currentStep" :title="currentStep.title" :subTitle="currentStep.description" />
   <div class="step-three d-lg-flex d-md-block">
      <div class="structure-area">
            <div v-show="!selected">
               <div v-show="!locked">
                  <div v-show="!selected" class='row'>
                     <div class="col-md-12">
                        <div class="col-md-3 float-left no-padding">
                           <DropDown
                              class="option-dd"
                              :options="['Course','Units']"
                              :override="'Course'"
                              @select="setDropDown"
                           />
                        </div>
                        <div class="col-md-9 float-right pr-0 pl-3">
                           <SearchBar
                              :placeHolder="this.dropdown == 'Course' ? 'Search for a course' : 'Search for units'"
                              :characterLimit="characterLimit"
                              @click="search"
                              :value="searchvalue"
                              @term="updateSearchValue"
                           />
                        </div>
                     </div>
                  </div>
                  <div v-if="searching"><Loading/></div>
                  <div v-if="results" class="results-box">
                     <Relationship v-for="result in results.courses" :key="result.id" :data="result" @clicked="fetchCourse"/>
                     <div v-if="pageLoading">
                        <Loading/>
                     </div>
                     <div v-if="results.courses.length == 0 && !searching">No results were found</div>
                  </div>
               </div>
               <div v-if="selectedItems.length > 0" class="str-landing">Your selected units:</div>
               <div v-if="units" id="unit-results" class="results-box"  v-on:scroll.passive='handleScroll'>
                  <Relationship v-for="unit in this.sortedRelationship" :key="unit.id" :data="unit" :location="unit.code+'-'+unit.order" @creditUpdate="updateCredits"  />
                  <div v-if="unitpageLoading">
                     <Loading/>
                  </div>
                  <div v-if="units.units.length == 0 && !unitSearching">No results were found</div>
               </div>
               <div v-if="unitSearching"><Loading/></div>
            </div>
            <div v-if="error">
               <div v-if="error.statusCode == 400" class="error">*{{ error.body }}</div>
               <div v-else class="user-info-error course-option-error"><ApiError :error="error.statusCode+' - '+error.body" @errorClicked="closeError" /></div>
            </div>
         <div v-if="selected">
            <div>
               <div class="str-landing">Your selected course:</div>
               <Relationship :data="selected" :pSearching="searching"  @clicked="deleteCourse" />
               <div v-if="searching"><Loading/></div>
            </div>
            <div v-if="course && course.structure[0]" class="">
               <Structure  :data="course.structure[0]" :location="course.code" />
            </div>
            <div v-if="course && !course.structure[0]" class="error">
                  * This item has no structure
            </div>
         </div>

      </div>
      <div class="">
         <SummarySelection />
      </div>
   </div>
   <div>
      <div v-if="currentStep.id == 2">
         <NavButton type="secondary" label="Select your info" @goTo="$router.push({name:'user-info'})" />
         <NavButton type="primary" label="View summary" :disabled="buttonDisable" @goTo="$router.push({name:'results'})" />
      </div>
      <div v-else>
         <NavButton type="secondary" label="Select course and units" @goTo="$router.push({name:'course-options'})" />
         <div><Disclaimer :disclaimersToShow="[1,2,3,4,5]"/></div>
      </div>
   </div>
</div>
</template>

<script>
   import SummarySelection from './summarySelection.vue'
   import PageInfo from './pageInfo.vue'
   import Relationship from 'client/components/application/Structure/relationship.vue'
   import Structure from './Structure/structure.vue'
   import Disclaimer from './disclaimer.vue'
   import ApiError from 'client/components/murdoch/ApiError.vue'
   import {dynamicSort} from 'common/models/sorting.js'
   import CourseType from 'common/models/course-type.js'

   import { mapGetters, mapActions, mapState } from 'vuex'
   export default {
      components: {
         SummarySelection,
         PageInfo,
         Relationship,
         Structure,
         Disclaimer,
         ApiError,
      },
      data: function(){
         return{
            characterLimit: 3,
            searching: false,
            pageLoading: false,
            results: null,
            units: null,
            unitSearching: false,
            unitpageLoading: false,
            error: false,
            selected: null,
            searchvalue: "",
            dropdown: "",
            buttonDisable: true,
         }
      },
      activated: function() {
         if(this.selectedItems.length){
            this.enableStep(3);
         }else{
            this.disableStep(3)
         }
      },

      computed: {
         ...mapState({
            course: state => state.selections.course,
            locked: state => state.selections.locked,
            selectedItems: state => state.selections.selectedItems,
            courseType: state => state.selections.courseType,
            studentID: state => state.selections.studentID,
         }),
         ...mapGetters({
            currentStep: 'getCurrentStep',
         }),
         orderedRelationship: function(){
            return this.units.units.sort( dynamicSort("order") );
         },
         unselectedRelationships: function(){
            var ur = this.orderedRelationship.filter(x => !this.selectedItems.some(y => y.id == x.id));
            return ur
         },
         sortedRelationship: function(){
            var sr = this.selectedItems.concat(this.unselectedRelationships);
            return sr;
         },
         mappedCourseType: function(){
            return this.studentID.courseTypeID;
         }
      },
      methods: {
         ...mapActions([
            'searchCourses',
            'searchUnits',
            'getCourse',
            'getPage',

            'setCourse',

            'enableStep',
            'disableStep',

            'addSelectedItem',
            'clearSelectedItems',
            'setLocked',
         ]),
         search(val){
            this.error = null;
            if(val.length == 0 ){
              this.results = null;
              if(this.units){
                  this.units.units = this.orderedRelationship.filter(x => this.selectedItems.includes(x));
               }else{
                  this.units = null;
               }
            }else{
               if(this.dropdown == "Course"){
                  this.courseSearch(val);
               }else{
                  this.unitSearch(val);
               }
            }
         },
         courseSearch(val){
            this.results = null;
            this.units = null;
            this.searching = true;
            this.searchCourses({id: val, type: this.mappedCourseType}).then(response =>{
               this.results = response;
               this.getCoursePage(response.links)
            }).catch(err =>{
               this.error = err;
            }).finally(() =>{
               this.searching = false;
            })
         },
         fetchCourse(val){
            this.searching = true;
            this.selected = val
            this.getCourse(val.id).then(response => {
               response.location = ""
               this.selected = response;
               this.addSelectedItem(response);
               this.setCourse(response);
               this.results = null;
            }).catch(err =>{
               this.error = err;
            }).finally(() =>{
               this.searching = false;
            })
         },
         deleteCourse(val){
            if(!this.locked){
               this.selected = null
               this.setCourse(null);
            }
         },
         getCoursePage(links){
            if(links.length > 0) {
               let nextLink = links.find(l => l.rel === 'next');
               if(nextLink){
                  this.pageLoading = true;
                  this.getPage(nextLink.href.replace("/api/", "")).then(response => {
                     this.results.courses = this.results.courses.concat(response.courses)
                     this.getCoursePage(response.links)
                  }).catch(err =>{
                     this.error = err;
                  }).finally(() =>{
                     this.pageLoading = false;
                  })
               }
            }
         },
         unitSearch(val){
            if(!this.unitpageLoading){
               this.results = null;
               if(this.units){
                  this.units.units = this.orderedRelationship.filter(x => this.selectedItems.includes(x));
               }else{
                  this.units = null;
               }
               this.unitSearching = true;
               this.searchUnits(val).then(response =>{
                  response.units.forEach(function (element) {
                     element.type = "Unit";
                  });
                  this.units = response;
               }).catch(err =>{
                  this.error = err;
               }).finally(() =>{
                  this.unitSearching = false;
               })
            }
         },
         getUnitPage(links){
            if(links.length > 0) {
               let nextLink = links.find(l => l.rel === 'next');
               if(nextLink){
                  this.unitpageLoading = true;
                  this.getPage(nextLink.href.replace("/api/", "")).then(response => {
                     response.units.forEach(function (element) {
                        element.type = "Unit";
                     });
                     this.units.units = this.units.units.concat(response.units)
                     this.units.links = response.links;
                  }).catch(err =>{
                     this.error = err;
                  }).finally(() =>{
                     this.unitpageLoading = false;
                  })
               }
            }
         },
         handleScroll(){
            let element = document.getElementById('unit-results');
            if ( (element.scrollHeight - element.scrollTop) - 200 < element.clientHeight ) {
               if(this.units.links && !this.unitpageLoading){
                  this.getUnitPage(this.units.links)
               }
            }
         },
         updateSearchValue(v){
            this.searchvalue = v;
         },
         updateCredits(c){
            this.credits = this.credits + c;
         },
         setDropDown(val){
            this.dropdown = val;
         },
         closeError(){
            this.error = null;
            this.searchvalue = "";
            this.results = null;
            this.units = null;
         }
      },
      watch: {
         $route (to, from){
            if(to.meta.step == 3){
               this.setLocked(true);
            }else{
               this.setLocked(false);
            }
         },
         selectedItems(){
            if(this.selectedItems.length){
               this.buttonDisable = false;
               this.enableStep(3);
            }else{
               this.buttonDisable = true;
               this.disableStep(3)
            }
         },
         mappedCourseType(){
            this.clearSelectedItems();
            this.results = null;
            this.searchvalue = "";
            this.selected = null;
         }
      }
   }
</script>

<style>
</style>
